import React, { useContext, useEffect, useState } from 'react'
import FilterButtonV2 from '../FilterButtonV2'
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputAdornment,
  MenuItem,
  Select,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material'
import { Appbox, LabelContainer, StatsNumber, StatsNumberContainer, StyledContainer } from './styledElements'
import SearchIcon from '@mui/icons-material/Search'
import AddIcon from '@mui/icons-material/Add'
import { FetchAgentProducts, FetchAppsV3, FetchMetricsV3 } from '../../libs/hooks/queries'
import ApplicationManagementTableV3 from './ApplicationManagementTableV3'
import { AuthContext } from '../../libs/contexts/authContext'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import DatePicker from 'react-datepicker'
import '../../theme/datepicker.scss'

// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
// import { DatePicker } from '@mui/x-date-pickers/DatePicker'
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
// import dayjs from 'dayjs'

const ApplicationManagementV3 = () => {
  // Your component logic here
  const { authObj, affiliateCode: affiliateCodeFromContext } = useContext(AuthContext)

  const [rows, setRows] = useState([])
  const [dayUnit, setDayUnit] = useState('all_time')
  const [filterBy, setFilterBy] = useState({
    affiliateCode: affiliateCodeFromContext,
    pagination: {
      limit: 5,
    },
    filters: {},
  })
  const [selectedProduct, setSelectedProduct] = useState('511801')
  const [searchBy, setSearchBy] = useState('')
  const [currCutOff, setCurrCutOff] = useState(null)
  const [selectedDate, setSelectedDate] = useState(null)
  const [page, setPage] = useState(1)
  const [customDate, setCustomDate] = useState({
    startDate: new Date(),
    endDate: null,
  })
  const { data: tableData, isLoading, isPending, isFetching, isError } = FetchAppsV3(filterBy)
  const { data: agentProducts, isFetching: fetchingAgentProducts } = FetchAgentProducts(affiliateCodeFromContext)
  const { data: metrics, isFetching: fetchingMetrics } = FetchMetricsV3(affiliateCodeFromContext)

  useEffect(() => {
    console.log({ tableData })
    if (!tableData) return
    // if (searchBy) {
    setRows(tableData.rows)
    // } else if (currCutOff === null) {
    //   setRows(data.rows)
    // } else {
    //   setRows((prev) => [...prev, ...data.rows])
    // }
  }, [tableData])

  useEffect(() => {
    console.log({ metrics })
  }, [metrics])

  const getMappedData = () => {
    const prefix = `${dayUnit}`
    const metricsObj = metrics && metrics.length > 0 ? { ...metrics[0] } : {}

    return {
      Quotes: metricsObj[`${prefix}_quotes`] || 0,
      'Underwriting Questions Submitted': metricsObj[`${prefix}_uwq_submitted`] || 0,
      'Applications Submitted to UW': metricsObj[`${prefix}_apps_submitted`] || 0,
      'Approved but Incomplete': metricsObj[`${prefix}_approved_incomplete`] || 0,
      'Applications Complete': metricsObj[`${prefix}_complete_app`] || 0,
      'Policy Issued': metricsObj[`${prefix}_issued_policies`] || 0,
      'Pending Lapse': metricsObj[`${prefix}_pending_lapse`] || 0,
    }
  }

  const handleFilterBy = (name) => (value) => {
    setRows([])
    setFilterBy((prev) => ({
      ...prev,
      filters: {
        [name]: value,
      },
      pagination: {
        limit: 5,
      },
    }))
  }

  const clearAllFilters = () => {
    setRows([])
    setFilterBy((prev) => ({
      ...prev,
      filters: {},
      pagination: {
        limit: 5,
      },
    }))
    // if (displayingFtapps) {
    //   setDisplayingFtapps(false)
    // }
    // setVisibleRows(appsList)
    // setBoxFilters((prev) => Object.fromEntries(Object.keys(prev).map((k) => [k, ''])))
  }

  const handleFetchNextRows = (pageNum) => {
    setPage(pageNum)
    setFilterBy((prev) => ({
      ...prev,
      pagination: {
        ...prev.pagination,
        cut_off: pageNum > 1 ? tableData?.listOfCursors?.[pageNum - 1] : null,
      },
    }))
  }

  const keyDownHandler = ({ key }) => {
    if (key === 'Enter' && searchBy && searchBy.length > 0) {
      setFilterBy((prev) => ({
        ...prev,
        pagination: {
          ...prev.pagination,
          cut_off: null,
        },
        filters: {
          ...prev.filters,
          arcId: searchBy,
        },
      }))
    }
  }

  const handleDayUnit = (e) => {
    const unit = e.target.value
    setDayUnit(unit)
    if (unit === 'all_time') {
      setRows([])
      setFilterBy((prev) => ({
        ...prev,
        filters: {
          ...prev.filters,
          date: null,
        },
      }))
    } else if (unit !== 'custom') {
      handleFilterBy('date')({ type: unit })
    }
  }

  const onChangeCustomDates = (dates) => {
    const [start, end] = dates
    setCustomDate({
      startDate: start,
      endDate: end,
    })
    if (dayUnit === 'custom' && start && end) {
      console.log('DATE: ', {
        type: 'custom',
        start: start,
        end: end,
      })
      handleFilterBy('date')({
        type: 'custom',
        start: start,
        end: end,
      })
    }
  }

  const labels = [
    'Quotes',
    'Underwriting Questions Submitted',
    'Applications Submitted to UW',
    'Approved but Incomplete',
    'Applications Complete',
    'Policy Issued',
    'Pending Lapse',
  ]

  const applicationStatusOptions = [
    'Quote Started',
    'Interview in Progress',
    'Pending Consent',
    'RUW',
    'Awaiting Additional Details',
    'Pending Decision',
    'Offer approved-pending payment details',
    'Pending signature(s)',
    'Pending Producer Certification',
    'Pending Issue',
    'Not Proceeded With',
    'Not Eligible',
    'MIB Pend',
    'Issued',
    'Lapsed',
  ]
  const ticketStatusOptions = ['All', 'Open', 'In Progress', 'Closed']

  const currentURL = window.location.href
  const newAppLink =
    currentURL.includes('localhost') || currentURL.includes('test')
      ? `https://bbq-eapp-qa.afficiency.com/?productId=511801&distributorId=5184&affiliateCode=${affiliateCodeFromContext}`
      : currentURL.includes('demo')
      ? `https://bbq-eapp-demo.afficiency.com/?productId=511801&distributorId=5184&affiliateCode=${affiliateCodeFromContext}`
      : `https://bbq-eapp.afficiency.com/?productId=511801&distributorId=5184&affiliateCode=${affiliateCodeFromContext}`

  return (
    <div style={{ backgroundColor: 'rgba(241, 243, 246, 1)', fontFamily: 'Roboto', minHeight: '100vh' }}>
      <Box sx={{ paddingTop: '50px', px: 1 }}>
        <Grid container rowSpacing={3} mt="12px" pb="12px">
          <Grid item lg={12} sm={12} xs={12}>
            <Box display={'flex'} justifyContent={'space-between'} mx={'auto'} width={'96%'} alignItems={'center'}>
              <Typography align="left" variant="h1" style={{ fontSize: '24px', verticalAlign: 'center' }} mb={1}>
                Application Management
              </Typography>
              <Box display={'flex'} gap={1}>
                <FormControl sx={{ minWidth: 120, bgcolor: '#FFF' }} size="small">
                  <Select
                    value={selectedProduct}
                    onChange={(e) => setSelectedProduct(e.target.value)}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    <MenuItem value="">Product</MenuItem>
                    {agentProducts?.map((i, idx) => {
                      return (
                        <MenuItem key={idx} value={i.productId}>
                          {i.productName}
                        </MenuItem>
                      )
                    })}

                    {/* <MenuItem value={10}>Last 30 Days</MenuItem>
                      <MenuItem value={20}>Last 90 Days</MenuItem>
                      <MenuItem value={30}>Current Month</MenuItem>
                      <MenuItem value={30}>Last Month</MenuItem>
                      <MenuItem value={30}>Current Year</MenuItem>
                      <MenuItem value={30}>Choose Dates</MenuItem> */}
                  </Select>
                </FormControl>
                <FormControl sx={{ minWidth: 120, bgcolor: '#FFF', position: 'relative' }} size="small">
                  <Select
                    value={dayUnit}
                    onChange={handleDayUnit}
                    inputProps={{ 'aria-label': 'Without label' }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    <MenuItem value={'all_time'}>All Dates</MenuItem>
                    <MenuItem value={'last_30d'}>Last 30 Days</MenuItem>
                    <MenuItem value={'last_90d'}>Last 90 Days</MenuItem>
                    <MenuItem value={'curr_month'}>Current Month</MenuItem>
                    <MenuItem value={'prev_month'}>Last Month</MenuItem>
                    <MenuItem value={'curr_year'}>Current Year</MenuItem>
                    <MenuItem value={'custom'}>Choose Dates</MenuItem>
                  </Select>
                  {dayUnit === 'custom' && (
                    <Box sx={{ position: 'absolute', transform: 'translate(-40%, 20%)', zIndex: 999 }}>
                      <DatePicker
                        selected={customDate.startDate}
                        onChange={onChangeCustomDates}
                        startDate={customDate.startDate}
                        endDate={customDate.endDate}
                        selectsRange
                        inline
                      />
                    </Box>
                  )}

                  {/* <Box sx={{ mt: 2 }}>
                        <DatePicker
                          label="Select Date"
                          value={selectedDate}
                          onChange={(newValue) => setSelectedDate(newValue)}
                        />
                      </Box> */}
                </FormControl>
              </Box>
            </Box>
          </Grid>

          <Grid
            width={'100%'}
            container
            rowSpacing={2}
            columnSpacing={2}
            mt={3}
            justifyContent={'center'}
            alignItems={'center'}
          >
            {/* <ResponsiveGridBox gap={1} display="grid"> */}
            {labels.map((label, idx) => (
              <Grid key={idx} item lg={1.7} md={3} xs={4}>
                <Appbox
                  onClick={() => {
                    // label !== 'Illustrations' && boxFilterFunc(label)
                  }}
                  // style={{ border: label !== 'Quotes' && boxFilters[label] !== '' ? '1px solid grey' : 'none' }}
                >
                  <StatsNumberContainer sx={{ margin: '5px 0 5px 0' }}>
                    <StatsNumber>
                      {!metrics || !metrics.length || fetchingMetrics ? 0 : getMappedData()[label]}
                    </StatsNumber>
                  </StatsNumberContainer>
                  <LabelContainer>
                    <Typography fontSize={'14px'}>{label}</Typography>
                  </LabelContainer>
                </Appbox>
              </Grid>
            ))}
            {/* </ResponsiveGridBox> */}
          </Grid>
        </Grid>
        <Typography align="left" fontSize={'12px'} paddingX="16px">
          Data displayed is current as of previous day.
        </Typography>
      </Box>
      <StyledContainer>
        <Grid item lg={12} sm={12} xs={12} sx={{ mt: 2 }}>
          <Grid container spacing={2} height="100%" justifyContent={'space-between'} alignItems={'center'} px={1}>
            <Grid item lg={6} sm={6} xs={6} display="flex" alignItems="center" justifyContent="start">
              <Typography fontSize={'20px'} fontWeight={'600'}>
                Applications
              </Typography>
            </Grid>
            <Grid item lg={2} sm={6} xs={6} display="flex" alignItems="center" justifyContent="end">
              <Tooltip
                title={filterBy.productName === 'All' && 'Please select a product to start a new application.'}
                PopperProps={{
                  style: { pointerEvents: 'none', marginTop: 0, marginLeft: 0 },
                }}
                margin="0px 0px 0px 100px"
              >
                <div>
                  <Button
                    sx={{
                      px: { lg: '18px', md: '18px', xs: '10px' },
                      textTransform: 'none',
                      height: '41px',
                      backgroundColor: '#3C4FB9',
                      color: 'white',
                      borderRadius: '100px',
                      mt: '10px',
                      '&:hover': {
                        backgroundColor: '#9BA5DF',
                        color: 'inherit',
                      },
                      '&:disabled': {
                        backgroundColor: '#C4CAF1',
                        color: 'white',
                        textTransform: 'none',
                      },
                    }}
                    disabled={filterBy.productName === 'All'}
                    // onClick={() => {
                    //   window.open(newAppLink, '_blank')
                    // }}
                    onClick={() =>
                      agentProducts && agentProducts.length > 0
                        ? window.open(agentProducts[0].productUrl, '_blank')
                        : window.open(newAppLink, '_blank')
                    }
                    startIcon={<AddIcon />}
                  >
                    New Application
                  </Button>
                </div>
              </Tooltip>
            </Grid>
          </Grid>
        </Grid>
        <Grid item lg={12} sm={12} xs={12}>
          <Grid container alignItems={'flex-end'} justifyContent={'space-between'} rowSpacing={1}>
            <Grid item lg={3} md={12} sm={12} xs={12}>
              <TextField
                type="search"
                variant="outlined"
                margin="normal"
                fullWidth
                label="Search for an application"
                value={searchBy}
                placeholder="Enter a policy number or Application ID Number"
                style={{
                  background: 'white',

                  marginBottom: '0px',
                }}
                onChange={(e) => {
                  if (e.target.value.trim().length === 0) {
                    setRows([])
                    setFilterBy((prev) => ({
                      ...prev,
                      filters: {},
                    }))
                  }
                  setSearchBy(e.target.value.trim())
                }}
                onKeyDown={keyDownHandler}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            {/* <StyledFilters> */}
            <Grid
              item
              lg={6}
              md={12}
              sm={12}
              xs={12}
              // sx={{
              //   display: 'flex',
              //   alignItems: { lg: 'center', md: 'center', sm: 'end', xs: 'end' },
              //   justifyContent: { lg: 'end', md: 'end', sm: 'start', xs: 'start' },
              // }}
            >
              <Box
                sx={{
                  display: 'flex',
                  gap: 1,
                  justifyContent: { lg: 'flex-end', sm: 'flex-start', xs: 'flex-start' },
                  flexWrap: 'wrap',
                  width: '100%',
                }}
              >
                <Box sx={{ minWidth: '213px' }}>
                  <FilterButtonV2
                    label="Application Status"
                    options={applicationStatusOptions}
                    onFilterChange={(selected) => handleFilterBy('status')(selected)}
                    value={filterBy?.filters?.status}
                    // disabled={true}
                    showCounter={false}
                  />
                </Box>

                <Stack
                  direction="row"
                  spacing={1}
                  alignItems={'center'}
                  justifyContent={'space-between'}
                  width={{ lg: 'auto', xs: '100%' }}
                >
                  <Button
                    sx={{
                      fontSize: { lg: '14px', md: '14px', xs: '12px' },
                      width: 'fit-content',
                      height: 'fit-content',
                      fontWeight: '700',
                      textTransform: 'none',
                    }}
                    onClick={clearAllFilters}
                  >
                    Clear All Filters
                  </Button>
                </Stack>
              </Box>
            </Grid>
            {/* </StyledFilters> */}
          </Grid>
        </Grid>
      </StyledContainer>
      <Grid item lg={12} sm={12} xs={12} px={2} pb={5}>
        <Grid container height="100%">
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <ApplicationManagementTableV3
              visibleRows={rows}
              fetchNextRows={handleFetchNextRows}
              fetchingRows={isLoading || isPending || isFetching}
              products={agentProducts}
              stopLoading={isError || filterBy?.filters?.arcId}
              total_pages={tableData && tableData?.listOfCursors ? Object.keys(tableData?.listOfCursors).length : null}
            />
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}

export default ApplicationManagementV3